import { Component } from 'react'
import Paper from 'material-ui/Paper'
import { Link } from 'react-router-dom'
import ModalCompleteTask from '../../../../modal-complete-task/index'
import ModalArNotCreated from 'components/modal-task-ar-not-created'
import Card from './components/card'
import intl from 'react-intl-universal';
import Session from 'utils/user-storage'
import SnackBar from 'material-ui/Snackbar'
import Loading from 'components/center-loading'
import { completeTask } from './visao-tarefas-mester.service'
import { confirmCancellationAwaitingCheck } from 'pages/stocks-detail/stocks-detail.service'
import './../mester.css'
import { formatErrorMessage } from 'utils/handle-error';
import { obterUrlTarefa } from '../../../../../services/tarefas/gerador-url-tarefa'
import ActionsCard from '../../../components/actionsCard'
import { TIPOS_TAREFA } from '../../../../../pages/tasks-vision'
import ModalLoadComposition from 'components/modal-load-composition'
import PropTypes from 'prop-types'

class VisaoTarefasMesterAmbevCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModalCompleteTask: false,
      isOpenModalArNotCreated: false,
      isOpenModalDetailingCargoComposition: false,
      requestCount: 0,
      showFeedback: false,
      messageFeedback: '',
      composition: null
    };
  }

  completarTarefa = () => this.setState({ isOpenModalCompleteTask: true })

  handleRequestClose = () => this.setState({ isOpenModalCompleteTask: false })

  showFeedback = (message) => this.setState({ showFeedback: true, messageFeedback: message })

  closeFeedback = () => this.setState({ showFeedback: false })

  handleFetch = (isFetching = true) => this.setState((prevState) => ({ requestCount: isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1 }))

  openModalArNotCreated = () => this.setState({ isOpenModalArNotCreated: true })

  closeModalArNotCreated = () => this.setState({ isOpenModalArNotCreated: false })

  openModalDetailingCargoComposition = () => this.setState({ isOpenModalDetailingCargoComposition: true })

  handleCompleteTask = async () => {
    try {
      this.handleFetch()
      await completeTask(this.props.dataCard.Id, Session.get().Id)
      this.showFeedback(intl.get('orders.feedback.taskCompletedSuccessfully'))
      await this.props.refreshCard()
      this.handleRequestClose()
    }
    catch (err) {
      this.showFeedback(err.response && err.response.data ? formatErrorMessage(err) : intl.get('commons.errorInTheSystem'))
    }
    finally {
      this.handleFetch(false)
    }
  }

  handleConfirmCancellationAwaitingCheck = async () => {
    try {
      this.handleFetch()
      await confirmCancellationAwaitingCheck(this.props.dataCard.IdOrigem)
      this.showFeedback(intl.get('orders.feedback.taskCompletedSuccessfully'))
      await this.props.refreshCard()
      this.handleRequestClose()
    }
    catch (err) {
      this.showFeedback(err.response && err.response.data ? formatErrorMessage(err) : intl.get('commons.errorInTheSystem'))
    }
    finally {
      this.handleFetch(false)
    }
  }

  handleDetailingCargoComposition = () => {
    try {
      this.handleFetch()
      this.setState({
        isOpenModalDetailingCargoComposition: true
      })
    }
    finally {
      this.handleFetch(false)
    }
  }

  handleCloseModalDetailingCargoComposition = async () => {
    await this.props.refreshCard()
    this.setState({
      isOpenModalDetailingCargoComposition: false
    })
  }

  generateCardTasks = () => {
    const task = this.props.dataCard;
    const user = Session.get();
    const url = obterUrlTarefa(task, user.TipoUsuario);
    switch (task.TipoTarefa) {
      case TIPOS_TAREFA.TAREFA_AR_NAO_CRIADO:
        return (
          <div className='card-ar'>
            <Card data={task} openModal={() => this.openModalArNotCreated()} />
          </div>
        )
      case TIPOS_TAREFA.TAREFA_COMPOSICAO_CARGA_AGUARDANDO_REVISAO:
      case TIPOS_TAREFA.TAREFA_COMPOSICAO_EM_RENEGOCIACAO_EMERGENCIAL:
      case TIPOS_TAREFA.TAREFA_COMPOSICAO_PARCIALMENTE_PREENCHIDA_AUTOPILOT:
        return (
          <div className='card-tarefa-revisao-composicao-carga'>
            <Card data={task} openModal={() => this.openModalDetailingCargoComposition()} />
          </div>
        )
      default:
        return (
          <Link to={url}>
            <Card data={task} />
          </Link>
        )
    }
  }

  render() {
    const task = this.props.dataCard;
    const user = Session.get();

    return (
      <div>
        <Loading isLoading={this.state.requestCount > 0} />
        <Paper zDepth={1} className='card-shop-mester' style={{ height: `250px` }}>
          {
            this.generateCardTasks()
          }
          {
            <ActionsCard
              task={task}
              completarTarefa={this.completarTarefa}
              handleCompleteTask={this.handleCompleteTask}
              handleConfirmCancellationAwaitingCheck={this.handleConfirmCancellationAwaitingCheck}
              handleDetailingCargoComposition={this.handleDetailingCargoComposition}
              user={user}
              startLoading={this.handleFetch}
              stopLoading={() => this.handleFetch(false)}
              refresh={this.props.refreshCard}
            />
          }
        </Paper>
        <ModalCompleteTask
          taskId={task.Id}
          open={this.state.isOpenModalCompleteTask}
          onCompleteTask={this.handleCompleteTask}
          onRequestClose={this.handleRequestClose}
        />

        <ModalArNotCreated
          tasks={task.TarefaPaymatchInformation}
          open={this.state.isOpenModalArNotCreated}
          close={() => this.closeModalArNotCreated()}
        />
        {this.state.isOpenModalDetailingCargoComposition &&
          <ModalLoadComposition
            open={this.state.isOpenModalDetailingCargoComposition}
            compositionId={task.IdOrigem}
            redirectRoute={this.props.redirect}
            handleRefresh={this.handleCloseModalDetailingCargoComposition}
            readingMode={false}
            close={this.handleCloseModalDetailingCargoComposition}
          />
        }
        <SnackBar
          message={this.state.messageFeedback}
          open={this.state.showFeedback}
          autoHideDuration={3000}
          onRequestClose={this.closeFeedback}
        />

      </div>
    )
  }
}

VisaoTarefasMesterAmbevCard.propTypes = {
  dataCard: PropTypes.shape({
    Id: PropTypes.number,
    IdOrigem: PropTypes.number,
    TipoTarefa: PropTypes.number,
    TarefaPaymatchInformation: PropTypes.object
  }),
  refreshCard: PropTypes.func,
  redirect: PropTypes.func
}

export default VisaoTarefasMesterAmbevCard
